<template>
    <div class="PlaceTheLoom" :class="{ locked: ready }"> 
      
      <transition name="PlaceTheLoom__loader">
        <div class="PlaceTheLoom__loader" v-if="status == 'loading'">
          <div class="PlaceTheLoom__icon">
            <img :src="require('@/commons/img/loading.png')">
          </div>
        </div>
      </transition>

      <template v-if="status == 'init' && ready">
        <Description ref="description" indice="place_the_loom"/>
        <div ref="block" class="Bottom"/>
      </template>  

      <!-- <transition name="PlaceTheLoom__logo"> -->

      <div class="PlaceTheLoom__logo" v-if="status == 'logo'">  
        <div ref="logo"><img :src="require('@/commons/img/logo.png')"></div>
        <div ref="worldbank" class="PlaceTheLoom__wrb"><WorldBank/></div>
        <Introduction v-if="use_information"/>
        <Options v-if="use_option"/>
      </div>

      <!-- </transition> -->

    </div> 
</template>

<script>

import gsap from "gsap"
import Description from "./Description.vue"
import Introduction from "./Introduction.vue"
import Options from "./Options.vue"
import WorldBank from "./WorldBank.vue"

export default {

  name: 'PlaceTheLoom',
  components: { Description, Introduction, Options, WorldBank },
  data: ()=>({
    tw: null,
    use_mask: false,
    use_information: false,
    use_option: false,
    ready: false,
    locked: false
  }),
  computed: {
    status() { return this.$store.getters['app/status'] },
  },
  watch: {
    status(nw) {
      if(nw == 'logo'){
        this.$nextTick(()=>{
          this.addIntroduction(0)
        })
      }
    },
  },


  beforeDestroy() {

    // console.log('BEFORE ////');

    if(this.tw)
        this.tw.kill()
  },


  mounted() {

    console.log('xxxx PlaceTheLoom');
    
    if(this.$root.route.from.params.section == 'weave'
    || this.$root.route.from.params.section == 'story'
    || this.$root.route.from.params.section == 'support'
    || this.$root.route.from.params.section == 'recenter')
      this.ready = true

    console.log(this.status + ' xxxxxx');


    this.$nextTick(()=>{ 
      if(this.status == 'logo')
        this.addIntroduction(1.5)
      else 
        this.addMotion() 
    })

  },
  methods:{

    addIntroduction(_delay) {

      console.log('xxxxx !');
      // this.use_information = true
      // return

      if(this.tw)
        this.tw.kill()

      this.tw = gsap.delayedCall(2.5, ()=> this.$store.commit('app/SYNC_AUDIO', 'trace'))

      gsap.timeline({})
          .add([
            gsap.from(this.$refs.logo, { duration: 3, scale: 0, delay: 1 + _delay }),
            gsap.from(this.$refs.worldbank, { 
              duration: 1, 
              opacity: 0, 
              delay: 4, 
              ease: 'none' })
          ])
          .to([this.$refs.logo, this.$refs.worldbank ], { 
            delay: 4, 
            duration: .5, 
            opacity: 0, 
            ease: 'none', 
            stagger: .2,
            onComplete: ()=>{ this.use_information = true } 
          })
    },

    introCompleted() {
      this.use_information = false
      this.$nextTick(()=>{
        this.use_option = true
      })
    },

    optionCompleted(arg) {

      if(arg == 'weave') {
        gsap.delayedCall(.1, ()=> this.$store.commit('app/UPDATE_STATUS', 'hide_logo'))
        gsap.delayedCall(1, ()=> { 
          this.ready = true
          this.$store.commit('app/UPDATE_STATUS', 'init')
          this.$nextTick(()=>{
            this.addMotion()
          })
        })
      } else {

        this.$router.push({ params: { section: 'story' } })


      }

    },



    addMotion() {

      // console.log('addMotion...'+ this.status);

      if(this.tw)
        this.tw.kill()

      // if(this.ready)
      //   this.tw = gsap.delayedCall(1.5, ()=> this.$store.commit('app/SYNC_AUDIO', 'option'))

      const delay = this.$root.route.from.params.section == 'weave'
                 || this.$root.route.from.params.section == 'recenter' ? 1 : .25
      if(this.$refs.description)    
        gsap.from(this.$refs.description.$el, { 
          duration: .5, 
          opacity: 0, 
          y: 200, 
          delay: delay, 
          ease: 'back.out',
        })
    },
  }
}

</script>

<style lang="stylus">
@import '~@/config/Settings'

.PlaceTheLoom
  position absolute
  color purple
  width 100%
  height 100%
  display flex
  flex-direction column
  align-items center
  justify-content flex-end
  pointer-events auto
  color white

  &.locked
    pointer-events none

  &__loader
    width 100%
    height 100%
    color white
    z-index 1000
    display flex 
    align-items center
    justify-content center
    transition transform .25s, opacity .5s
    opacity 1
   
    &-enter 
      opacity 0
    &-leave-active
      opacity 0

  &__icon 
    
    width 48px
    height 48px
    animation spin 2s linear infinite
  
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

  &__description 
    transition transform .25s, opacity .5s
    opacity 1
   
    &-enter 
      transform translateY(200px)
      opacity 0
    &-leave-active
      opacity 0

  &__logo 
    width 100%
    height 100%
    position absolute
    top 0
    left 0
    background rgb(36, 31, 63)
    background linear-gradient(0deg, rgba(0, 0, 0, .9) 50%, rgba(36, 31, 63, .9) 100%)
    z-index 20000
    transition opacity .75s
    opacity 1

    display flex
    align-items center
    justify-content center
   
    &-enter 
    &-leave-active
      opacity 0

  &__wrb 
    position absolute
    width 120px
    bottom 24px
    right 32px

</style>


